import React, { useState, useEffect } from "react";
import { FaSpinner } from "react-icons/fa";
import { Table } from "react-bootstrap";
import Select from "react-select";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { format, eachDayOfInterval, parseISO } from "date-fns";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

const AttendanceStatement = () => {
  const dispatch = useDispatch();

  const [statement, setStatement] = useState([]);
  console.log("statement::",statement);
  
  const [monthOpt, setMonthOpt] = useState([]);
  const [employeeOption, setEmployeeOption] = useState([]);
  const [monthDays, setMonthDays] = useState([]);

  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(updateNavbarHeading("Attendance Statement"));
    fetchIndexApi();
  }, []);

  const [firstTimeMonth, setFirstTimeMonth] = useState(null)

  const fetchIndexApi = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}attendanceStatement-getdata`);
      if (response?.status === 200) {
        const monthOptions = response?.data?.month?.map((item) => ({
          value: item.value,
          label: item.text,
          StartDate: item.StartDate,
          EndDate: item.EndDate
        }))?.reverse();

        setMonthOpt(monthOptions);

        if (monthOptions?.length > 0) {
          setFirstTimeMonth(monthOptions[0].value)
          setSelectedMonth(monthOptions[0].value); // default month
        }

        const employeeOptions = response?.data?.employeelist?.map((item) => ({
          value: item.value,
          label: item.text,
        }));

        setEmployeeOption(employeeOptions);
      }
    } catch (error) {
      console.error("Fetching Error ", error);
    }
  };

  const fetchAttendanceStatement = async (monthId, employeeId) => {
     setStatement([])
    try {
      setLoading(true);
      const response = await GetServiceCaller(
        `${API_URL}attendanceStatement?P_MonthID=${monthId || ''}&P_EmployeeID=${employeeId || ""}`
      );

      if (response?.status === 200) {
        const data = response?.data?.data;
        setStatement(data);

        const selectedMonthData = monthOpt?.find(
          (item) => item.value === monthId
        );

        if (selectedMonthData) {
          const startDate = parseISO(selectedMonthData.StartDate);
          const endDate = parseISO(selectedMonthData.EndDate);

          const daysArray = eachDayOfInterval({
            start: startDate,
            end: endDate,
          }).map((date) => ({
            day: format(date, "EEE"), // Mon, Tue, etc.
            date: format(date, "dd"), // 01, 02, etc.
            fullDate: date,
          }));

          setMonthDays(daysArray);
        }
      }
    } catch (error) {
      console.error("Error fetching attendance data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (firstTimeMonth !== null) {
      fetchAttendanceStatement(selectedMonth, selectedEmployee);
    }
  }, [firstTimeMonth]);

  const handleGetData =async () => {
    if (!selectedMonth) {
      alert("Please select a month first");
      return;
    }
    setStatement([])

     try {
      setLoading(true);
      const response = await GetServiceCaller(
        `${API_URL}attendanceStatement?P_MonthID=${selectedMonth || ''}&P_EmployeeID=${selectedEmployee || ""}`
      );

      if (response?.status === 200) {
        const data = response?.data?.data;
        setStatement(data);

        const selectedMonthData = monthOpt?.find(
          (item) => item.value === selectedMonth
        );

        if (selectedMonthData) {
          const startDate = parseISO(selectedMonthData.StartDate);
          const endDate = parseISO(selectedMonthData.EndDate);

          const daysArray = eachDayOfInterval({
            start: startDate,
            end: endDate,
          }).map((date) => ({
            day: format(date, "EEE"), // Mon, Tue, etc.
            date: format(date, "dd"), // 01, 02, etc.
            fullDate: date,
          }));

          setMonthDays(daysArray);
        }
      }
    } catch (error) {
      console.error("Error fetching attendance data:", error);
    } finally {
      setLoading(false);
    }
  };

const handleReset = () => {
  const defaultMonth = monthOpt.find((m) => m.value === firstTimeMonth);

  setSelectedEmployee(null);
  setSelectedMonth(firstTimeMonth);
  setStatement([]);
  setMonthDays([]);

  if (defaultMonth) {
    fetchAttendanceStatement(firstTimeMonth, null);
  }
};


  return (
    <div className="container-fluid" id="skill_section">
      <div className="container-fluid" id="skill-table-area">
        <div className="mt-2">
          <div className="row align-items-end">
            <div className="col-md-3">
              <label className="form-label">Month</label>
              <Select
                onChange={(option) => setSelectedMonth(option?.value)}
                value={monthOpt.find((o) => o.value === selectedMonth)}
                options={monthOpt}
                placeholder="Select Month"
                isClearable
              />
            </div>

            <div className="col-md-3">
              <label className="form-label">Employee</label>
              <Select
                onChange={(option) => setSelectedEmployee(option?.value)}
                value={employeeOption.find((o) => o.value === selectedEmployee) || null}
                options={employeeOption}
                placeholder="Select Employee"
                isClearable
              />
            </div>

            <div className="col-md-6 text-end">
              <button className="custom-btn me-2" type="button" onClick={handleReset}>
                Reset
              </button>
              <button
                className="custom-btn"
                type="button"
                onClick={handleGetData}
                disabled={loading || !selectedMonth}
              >
                {loading ? "Loading" : "Get Data"}
              </button>
            </div>
          </div>

          <div className="mt-2">
            {loading ? (
              <div className="text-center py-4">
                <FaSpinner className="spinner" />
              </div>
            ) : (
              <>
                <hr />
                <div className="table-responsive">
                  <Table striped bordered hover>
                    <thead id="thcolor" className="text-center">
                      <tr>
                        <th>Employee</th>
                        {monthDays.map((d, index) => (
                          <th key={index}>{`${d.day} ${d.date}`}</th>
                        ))}
                        <th>Leave Days</th>
                        <th>C-OFF Days</th>
                        <th>Present Days</th>
                        <th>Payable Days</th>
                        <th>Confirmed</th>
                        <th>Payroll Calculated</th>
                        <th>Remark</th>
                      </tr>
                    </thead>
                    <tbody>
                      {statement?.length > 0 ? (
                        statement.map((item, index) => (
                          <tr key={index}>
                            <td>{item.EmployeeName || "N/A"}</td>
                            {monthDays.map((_, dayIndex) => {
                              const dayKey = `Day${dayIndex + 1}`;
                              return (
                                <td key={dayKey} className="text-center">
                                  {item[dayKey] ?? "-"}
                                </td>
                              );
                            })}
                            <td className="text-center">{item.LeaveDays ?? "-"}</td>
                            <td className="text-center">{item.coffDays ?? "-"}</td>
                            <td className="text-center">{item.PresentDays ?? "-"}</td>
                            <td className="text-center">{item.payDays ?? "-"}</td>
                            <td className="text-center">{item.IsConfirmed ?? "-"}</td>
                            <td className="text-center">{item.PayrollCalculated ?? "-"}</td>
                            <td className="text-center">{item.Remark ?? "-"}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={monthDays.length + 8} className="text-center">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceStatement;
